import { CommonModule } from '@angular/common';
import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FichaDaObraService } from 'src/app/ficha-da-obra/service/ficha-da-obra.service';
import { ProfileDataService } from 'src/app/header/perfil-usuario/service/profile-data.service';
import { AuthService } from 'src/app/shared/services/auth/auth.service';

@Component({
  selector: 'app-modal-reportar-erro-contato',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './modal-reportar-erro-contato.component.html',
  styleUrl: './modal-reportar-erro-contato.component.scss'
})
export class ModalReportarErroContatoComponent implements OnInit{
  @Input() contactId: number | null = null;
  @Input() contactName: string = '';
  @Input() contactRole: string = '';
  @Input() contactEmail: string = '';
  @Input() contactPhone: string = '';
  @Input() constructorId: number | null = null;
  @Input() constructorName: string = '';
  @Input() workId: number | null = null;
  @Input() workName: string = '';
  @Input() moduleId: number | null = null;
  @Input() module: string = '';
  @Input() companyId: number | null = null;
  @Input() companyName: string = '';

  /** Fora da ficha da obra (ex.: contatos da empresa) não há obra vinculada. */
  @Input() exibirObra = true;
  @Input() rotuloEmpresa = 'Construtora';

  @Output() close = new EventEmitter<void>();
  @Output() loading = new EventEmitter<boolean>();

  private _profileDataService = inject(ProfileDataService);
  private _fichaDaObraService = inject(FichaDaObraService);
  private readonly authService = inject(AuthService);

  message = '';
  sucesso = false;
  submitted = false;

  ngOnInit(): void {
    this._profileDataService.loadProfileData().subscribe();
  }

  get isValid(): boolean {
    return !!this.message.trim();
  }

  enviar(): void {
    this.submitted = true;
    if (!this.isValid) return;

    this.loading.emit(true);

    const profileData = this._profileDataService.getProfileData();
    const userId = this.authService.userID;

    const payload = {
      contactId:       this.contactId,
      contactName:     this.contactName,
      contactRole:     this.contactRole || null,
      contactEmail:    this.contactEmail || null,
      contactPhone:    this.contactPhone || null,
      constructorId:   this.constructorId,
      constructorName: this.constructorName || null,
      workId:          this.workId,
      workName:        this.workName,
      moduleId:        this.moduleId,
      module:          this.module || null,
      message:         this.message.trim(),
      userId:          userId ? parseInt(userId) : null,
      userName:        profileData?.name || '',
      userEmail:       profileData?.email || '',
      userPhone:       profileData?.phone || '',
      companyId:       this.companyId,
      companyName:     this.companyName,
    };
    this._fichaDaObraService.reportarErroContato(payload).subscribe({
      next: () => {
        this.sucesso = true;
        this.loading.emit(false);
      },
      error: () => {
        this.loading.emit(false);
      }
    });
  }

  fechar(): void {
    this.close.emit();
  }
}

